<template>
  <div class="row mb-4 mx-0 py-3" v-for="data in meetingHistoryData" :key="data.id" style="border-bottom: 2px solid #D8D8D8">

    <div class="col-6 col-md-4 col-lg-1 mb-3">
      <span class="label-bold">Termin:</span> <br/>
      <span class="text-break">{{ data.termin }}</span>
    </div>
    <div class="col-6 col-md-4 col-lg-1 mb-3">
      <span class="label-bold">Start:</span> <br/>
      {{ data.startTime }}
    </div>
    <div class="col-6 col-md-4 col-lg-1 mb-3">
      <span class="label-bold">Ende:</span> <br/>
      {{ data.endTime }}
    </div>
    <div class="col-6 col-md-4 col-lg-1 mb-3">
      <span class="label-bold">Anwesenheit:</span> <br/>
      {{ data.presenceTranslation }}
    </div>
    <div class="col-6 col-md-4 col-lg-1 mb-3 text-md-right text-lg-left">
      <span class="label-bold">Einheiten:</span> <br/>
      {{ data.units }}
    </div>

    <div class="col-6 col-md-4 col-lg-auto mb-3" v-if="operationType !== 'modular_integration_coaching'">
      <span class="label-bold">Overwrite:</span> <br/>
      {{ data?.overwrite ? 'Ja' : 'Nein' }}
    </div>

    <div class="col-12 col-md-4 col-lg-auto mb-3">
      <span class="label-bold">Unterschrift:</span> <br/>
      <template v-if="data?.privateCoaching?.digitalSignature">
        <span v-if="!data.digitalSignatureImage" style="color: #cf1020; font-size: 0.85rem;">
          Fehlende Unterschrift
        </span>
        <span v-else>Ja</span>
      </template>
      <template v-else>
        {{ data?.signature ? 'Ja' : 'Nein' }}
      </template>
    </div>

    <div class="col-4 col-lg-1 mb-3">
      <span class="label-bold">Abger.:</span> <br/>
      {{ data?.billed ? 'Ja' : 'Nein' }}
    </div>
    <div class="col-4 col-lg-1 mb-3">
      <span class="label-bold">Bezahlt:</span> <br/>
      {{ data?.paid ? 'Ja' : 'Nein' }}
    </div>
    <div class="col-4 col-lg-1 mb-3">
      <span class="label-bold">Hausb.:</span> <br/>
      {{ data?.homeVisit ? 'Ja' : 'Nein' }}
    </div>

    <div class="col-12 mt-2 bg-light p-2 rounded">
      <div class="row">
        <div class="col-12 col-md-6 mb-2 mb-md-0" v-if="operationType !== 'modular_integration_coaching'">
          <span class="module-label-bold">Coachart:</span> {{ data.coachTypeTranslation }}
        </div>
        <div class="col-12 col-md-6">
          <span class="module-label-bold">Coach:</span> {{ data.coach?.firstName }} {{ data.coach?.lastName }}
        </div>
      </div>
    </div>

    <div class="col-12 mt-3" v-if="(operationType === 'go_work_mobile' || operationType === 'compass')">
      <div class="row">
        <div class="col-12 col-md-6 mb-2" v-if="operationType === 'go_work_mobile'">
          <span class="module-label-bold">Modul:</span><br/> {{ data.module?.name }}
        </div>
        <div class="col-12 col-md-6">
          <span class="module-label-bold">Abschnittsnummer:</span><br/> {{ data.sectionNumber }}
        </div>
      </div>
    </div>

    <div class="col-12 mt-3" v-if="operationType !== 'modular_integration_coaching' && data.meetingType === 'pr'">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <span class="module-label-bold">Sitzungsthema:</span><br/>
          {{ data.meetingTopic }}
        </div>
        <div class="col-12 col-md-6">
          <span class="module-label-bold">Beschreibung:</span><br/>
          <span class="text-muted small">{{ truncateText(data.description) }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 mt-3 p-3 border rounded bg-white" v-if="operationType === 'modular_integration_coaching'">
      <div class="row g-3">
        <div class="col-12 col-md-6"><span class="module-label-bold">Kontrolle vereinbarte Ziele:</span><br/>{{ data.moduleGoal5FromLastMeeting?.name }}</div>
        <div class="col-12 col-md-6"><span class="module-label-bold">Handlungsempfehlung:</span><br/>{{ data.moduleGoal6FromLastMeeting?.name }}</div>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-12 col-md-6"><span class="module-label-bold">Modul:</span><br/> {{ data.module?.name }}</div>
        <div class="col-12 col-md-6"><span class="module-label-bold">Abschnitt:</span><br/> {{ data.sectionNumber }}</div>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-12 col-md-4"><span class="module-label-bold">Richtziel:</span><br/> {{ data.moduleGoal1?.name }}</div>
        <div class="col-12 col-md-4"><span class="module-label-bold">Grobziel:</span><br/> {{ data.moduleGoal2?.name }}</div>
        <div class="col-12 col-md-4"><span class="module-label-bold">Feinziel:</span><br/> {{ data.moduleGoal3?.name }}</div>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-12 col-md-6"><span class="module-label-bold">Maßnahmen:</span><br/> {{ data.moduleGoal4?.name }}</div>
        <div class="col-12 col-md-6"><span class="module-label-bold">Bis wann:</span><br/> {{ data.moduleGoalDate }}</div>
      </div>
    </div>

    <div class="col-12 mt-3 text-right" v-if="operationType !== 'modular_integration_coaching'">
      <span class="module-label-bold">Geva-Potentialanalyse:</span>
      <span class="badge" :class="data?.geva ? 'badge-success' : 'badge-light'">
         {{ data?.geva ? 'Ja' : 'Nein' }}
       </span>
    </div>
  </div>

  <ModalConfirm
      v-model="showRevertHistoryModal"
      confirmation-question="Sind Sie sicher, dass Sie die Daten wiederherstellen?"
      :onConfirm="revertHistory">
  </ModalConfirm>
</template>




<!--<template>-->
<!--  <div class="row mb-5" v-for="data in meetingHistoryData" :key="data.id" style="border-bottom: 1px solid #D8D8D8">-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Termin:</span> <br/>-->
<!--      <span>{{ data.termin }}</span>-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Startzeit:</span> <br/>-->
<!--      {{ data.startTime }}-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Endzeit:</span> <br/>-->
<!--      {{ data.endTime }}-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Anwesenheit:</span> <br/>-->
<!--      {{ data.presenceTranslation }}-->
<!--    </div>-->
<!--    <div class="col-1 text-right">-->
<!--      <span class="label-bold">Einheiten :</span> <br/>-->
<!--      {{ data.units }}-->
<!--    </div>-->
<!--    <div class="col-auto" v-if="operationType !== 'modular_integration_coaching'">-->
<!--      <span class="label-bold">Überschreiben:</span> <br/>-->
<!--      {{ data?.overwrite ? 'Ja' : 'Nein' }}-->
<!--    </div>-->
<!--    <div class="col-auto">-->
<!--      <span class="label-bold">Unterschrift:</span> <br/>-->
<!--      <template v-if="data?.privateCoaching?.digitalSignature">-->
<!--        <template v-if="!data.digitalSignatureImage">-->
<!--          <span style="color: #cf1020">-->
<!--            Fehlende Digitale Unterschrift-->
<!--          </span>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          Ja-->
<!--        </template>-->
<!--      </template>-->
<!--      <template v-else>-->
<!--        <template v-if="data?.signature">-->
<!--          Ja-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          Nein-->
<!--        </template>-->
<!--      </template>-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Abgerechnet:</span> <br/>-->
<!--      {{ data?.billed ? 'Ja' : 'Nein' }}-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Bezahlt:</span> <br/>-->
<!--      {{ data?.paid ? 'Ja' : 'Nein' }}-->
<!--    </div>-->
<!--    <div class="col-1">-->
<!--      <span class="label-bold">Hausbesuch:</span> <br/>-->
<!--      {{ data?.homeVisit ? 'Ja' : 'Nein' }}-->
<!--    </div>-->

<!--    <div class="col-12 mt-4">-->
<!--      <div class="row">-->
<!--        <div class="col-6" v-if="operationType !== 'modular_integration_coaching'">-->
<!--          <span class="module-label-bold">Coachart :</span> {{ data.coachTypeTranslation }}-->
<!--        </div>-->
<!--        <div class="col-6">-->
<!--          <span class="module-label-bold">Coach:</span> {{ data.coach?.firstName }} {{ data.coach?.lastName }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="col-12 mt-2" v-if="operationType === 'go_work_mobile' || operationType === 'compass'">-->
<!--      <div class="row">-->
<!--        <div class="col-6 mt-1 mb-1" v-if="operationType === 'go_work_mobile'">-->
<!--          <span class="module-label-bold">Modul:</span><br/> {{ data.module?.name }}-->
<!--        </div>-->
<!--        <div class="col-6 mt-1 mb-1">-->
<!--          <span class="module-label-bold">Abschnittsnummer:</span><br/> {{ data.sectionNumber }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="col-12 mt-2"-->
<!--         v-if="operationType !== 'modular_integration_coaching' && data.meetingType === 'pr'">-->
<!--      <div class="row">-->
<!--        <div class="col-6">-->
<!--          <span class="module-label-bold">Sitzungsthema  :</span><br/>-->
<!--          {{ data.meetingTopic }}-->
<!--        </div>-->
<!--        <div class="col-6">-->
<!--          <span class="module-label-bold">Beschreibung :</span><br/>-->
<!--          {{ truncateText(data.description) }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="row p-2" v-if="operationType === 'modular_integration_coaching'">-->
<!--      <div class="col-8"></div>-->

<!--      <div class="col-6 mt-2">-->
<!--        <span class="module-label-bold">Kontrolle vereinbarte Ziele:</span><br/>{{-->
<!--          data.moduleGoal5FromLastMeeting?.name-->
<!--        }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-2">-->
<!--        <span class="module-label-bold">Handlungsempfehlung:</span><br/>{{ data.moduleGoal6FromLastMeeting?.name }}-->
<!--      </div>-->

<!--      <div class="col-6 mt-2 mb-1">-->
<!--        <span class="module-label-bold">Modul:</span><br/> {{ data.module?.name }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-2 mb-1">-->
<!--        <span class="module-label-bold">Abschnittsnummer:</span><br/> {{ data.sectionNumber }}-->
<!--      </div>-->

<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Richtziel:</span><br/> {{ data.moduleGoal1?.name }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Grobziel:</span><br/> {{ data.moduleGoal2?.name }}-->
<!--      </div>-->

<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Feinziel:</span><br/>{{ data.moduleGoal3?.name }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Maßnahmen:</span><br/>{{ data.moduleGoal4?.name }}-->
<!--      </div>-->
<!--      <div class="col-12 mt-1">-->
<!--        <span class="module-label-bold">Bis wann:</span>{{ data.moduleGoalDate }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Zielkontrolle:</span><br/>{{ data.moduleGoal5?.name }}-->
<!--      </div>-->
<!--      <div class="col-6 mt-1">-->
<!--        <span class="module-label-bold">Handlungsempfehlung:</span><br/>{{ data.moduleGoal6?.name }}-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="col-12 mt-2" v-if="operationType !== 'modular_integration_coaching'">-->
<!--      <div class="row">-->
<!--        <div class="col-10"></div>-->
<!--        <div class="col-2">-->
<!--          <span class="module-label-bold">Geva-Potentialanalyse:</span>-->
<!--          {{ data?.geva ? 'Ja' : 'Nein' }}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--&lt;!&ndash;    <div class="d-flex justify-content-center w-100 mt-3 mb-4">&ndash;&gt;-->
<!--&lt;!&ndash;      <button class="btn btn-primary" type="submit" @click.stop="handleRevertHistoryModal(data?.id, data.meetingType)">&ndash;&gt;-->
<!--&lt;!&ndash;        Geschichte wiederherstellen&ndash;&gt;-->
<!--&lt;!&ndash;      </button>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--    <div class="col-12 mt-2 mb-2"></div>-->
<!--  </div>-->

<!--  <ModalConfirm-->
<!--      v-model="showRevertHistoryModal"-->
<!--      confirmation-question="Sind Sie sicher, dass Sie die Daten wiederherstellen?"-->
<!--      :onConfirm="revertHistory">-->
<!--  </ModalConfirm>-->
<!--</template>-->

<script setup>
import {defineProps, onMounted, ref, toRefs} from "vue";
import {CloseToast, ErrorToast} from "@/components/VueToast";
import portalPrivateCoachingService from "@/api/Portal/PrivateCoaching";
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import {truncateText} from "@/shared/portal/commonFunctions";

const meetingHistoryData = ref([])
const showRevertHistoryModal = ref(false)
const isLoaded = ref(false);
const historyId = ref(null)
const meetingType = ref('')

const props = defineProps({
  meetingId: {
    type: [Number, String],
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  }
});

const meetingId = toRefs(props)['meetingId'];
const operationType = toRefs(props)['operationType'];

async function getMeetingHistoryData() {
  try {
    const {data} = await portalPrivateCoachingService.getMeetingDataHistoryList(+meetingId.value);

    meetingHistoryData.value = data.data
  } catch (error) {
    await ErrorToast(error);
  }
}


async function revertHistory() {
  try {
    await portalPrivateCoachingService.revertMeetingHistory(meetingType.value, +meetingId.value, +historyId.value);

    meetingType.value = '';
    historyId.value = '';
    showRevertHistoryModal.value = false;
  } catch (error) {
    await ErrorToast(error);
  }
}


function handleRevertHistoryModal(historyMeetingId, historyMeetingType) {
  showRevertHistoryModal.value = true;
  historyId.value = historyMeetingId;
  meetingType.value = historyMeetingType
}

onMounted(async () => {
  CloseToast();
  await getMeetingHistoryData(meetingId);

  isLoaded.value = true;
});
</script>

<style scoped>
.label-bold {
  font-size: 16px;
  font-weight: bold;
}

.module-label-bold {
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}
</style>